import { useState, useCallback } from 'react';
import { MediaFile } from '../types';

interface UseUploadLogicProps {
  handleUploadFile: (file: File) => Promise<void>;
  onUploadComplete?: () => void;
  onUploadError?: (error: string) => void;
}

export const useUploadLogic = ({
  handleUploadFile,
  onUploadComplete,
  onUploadError,
}: UseUploadLogicProps) => {
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const uploadFiles = useCallback(
    async (mediaFiles: MediaFile[]) => {
      if (mediaFiles.length === 0) return;

      setLoading(true);
      setUploadProgress(0);

      try {
        const totalFiles = mediaFiles.length;

        for (let i = 0; i < mediaFiles.length; i++) {
          const file = mediaFiles[i];
          await handleUploadFile(file.file);

          const progress = ((i + 1) / totalFiles) * 100;
          setUploadProgress(progress);

          if (file.preview) {
            URL.revokeObjectURL(file.preview);
          }
        }

        setUploadProgress(0);
        onUploadComplete?.();
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Error al subir los archivos';
        console.error('Upload failed:', err);
        onUploadError?.(errorMessage);
      } finally {
        setLoading(false);
      }
    },
    [handleUploadFile, onUploadComplete, onUploadError]
  );

  return {
    loading,
    uploadProgress,
    uploadFiles,
  };
};
